var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.newsDetail.title))]),_c('div',{staticClass:"date"},[_vm._v("\n      时间："),_c('span',[_vm._v(_vm._s(_vm.newsDetail.gmtCreate))])]),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.newsDetail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }